import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { MyContext } from '../Context/MyContext';
import axios from 'axios';
import { API_URL } from '../Api/api';
import { isNearLocationFeatureEnabled } from '../utils/nearLocationConfig';
import LanguageSelector from './LanguageSelector';
import WebChat from './WebChat';
import './HeaderCornerActions.css';

const LocationIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20" aria-hidden>
    <circle cx="12" cy="12" r="3" />
    <path d="M12 2v3M12 19v3M2 12h3M19 12h3" />
    <circle cx="12" cy="12" r="8" strokeDasharray="2 3" />
  </svg>
);

const HeaderCornerActions = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { nearLocationConfig, localizationEnabled } = useContext(MyContext);

  const [webChatEnabled, setWebChatEnabled] = useState(false);
  const showChat = webChatEnabled;
  const showNearby = isNearLocationFeatureEnabled(nearLocationConfig);
  const showLanguage = localizationEnabled !== false && !showChat;

  useEffect(() => {
    axios.get(`${API_URL}/chat/config`)
      .then((res) => setWebChatEnabled(!!res.data?.show_web_chat))
      .catch(() => setWebChatEnabled(false));
  }, []);

  useEffect(() => {
    const onNearby = location.pathname === '/nearby-locations';
    document.body.classList.toggle('nearby-locations-active', onNearby);
    return () => document.body.classList.remove('nearby-locations-active');
  }, [location.pathname]);

  if (!showNearby && !showLanguage && !showChat) return null;

  return (
    <div className="header-corner-actions" aria-label="Quick actions">
      {showNearby && (
        <button
          type="button"
          className="hca-btn hca-btn--location"
          onClick={() => navigate('/nearby-locations')}
          aria-label="Nearby locations"
        >
          <span className="hca-btn__icon"><LocationIcon /></span>
          <span className="hca-btn__label">Nearby Locations</span>
        </button>
      )}
      {showChat ? <WebChat /> : (showLanguage && <LanguageSelector variant="header" />)}
    </div>
  );
};

export default HeaderCornerActions;
